<template>
	<div class="shareactivity">
		<Loading msg="loading" v-if="!isload" />
		<div class="share_inner" v-else>
	   <div class="pro_link pro_35_discount" @click="$parent.goPromotion('35_online-promotion')"></div>
	   <div class="pro_link pro_35" @click="$parent.goPromotion('35_online-promotion')"></div>
	   <div class="pro_link pro_29" @click="$parent.goPromotion('29_online-promotion')"></div>
    <img src="../assets/images/activity_to_home.png" class="back_to_home" @click="$parent.goHome();" alt="">
    <!-- <span class="back_to_home" @click="$parent.goBack();">BACK</span> -->
		</div>
      
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
var wx = require("weixin-js-sdk");

export default {
  name: "ShareActivity",
  data() {
    return {
      isload: true,
      in_weapp: false, //是否在小程序
      share_img: "",
    };
  },

  created() {
    console.log("shareactivity created", this);
  },
  mounted() {
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
    document.querySelector('.expert_consultant').style.display='none';
  },
  methods: {
      goHome: function(){
      if (this.in_weapp) {
        wx.miniProgram.switchTab({
          url: "/mall/mall"
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/shop.html";
      }
    },


    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
  .back_to_home_div{
    // position:fixed;
    position:relative;
    width:1.92rem;
    height:1.92rem;
    bottom:1.8rem;
    right:0.72rem;
    z-index:999999;
  }
.back_to_home{
  box-sizing:border-box;
  position:fixed;
  width:1.92rem;
  height:1.92rem;
  bottom:1.8rem;
  right:0.72rem;
  z-index:999999;
  border-radius:50%;
  -webkit-box-shadow:3px 3px 10px 1px rgba(255,124,91,0.87);
  box-shadow:3px 3px 10px 1px rgba(255,124,91,0.87);
  // background:rgba(255,124,91,0.87);
  // color:@font-c-f;
  // font-size:24/50rem;
  // text-align:center;
  // line-height:1.92rem;
}
.back_btn {
  position: fixed;
  top: 30/50rem;
  left: 0;
  z-index: 99999;
  width: 118/50rem;
  height: 54/50rem;
}

.share_inner{
  position:relative;
  margin:0 auto;
  width:750/50rem;
  height:9974/50rem;
  background:url('../assets/images/share_activity_bg.png') no-repeat 0 0;
  background-size:100%;
  .pro_35_discount{
    position:absolute;
    top:5240/50rem;
    left:0;
    width:100%;
    height:200/50rem;
  }
    .pro_35{
    position:absolute;
    top:6050/50rem;
    left:0;
    width:100%;
    height:300/50rem;
  }
    .pro_29{
    position:absolute;
    top:6640/50rem;
    left:0;
    width:100%;
    height:300/50rem;
  }
}
</style>
